import { AnyAction } from '@reduxjs/toolkit';
import {
  COMPANY_CHANGED,
  SET_CURRENTLY_EDITING_SHOPPING_CART_LINE_DATA,
  TRIGGER_ADD_TO_SHOPPING_CART,
  SET_TRIGGER_SHOW_ADDED_TO_CART_MODAL,
  SET_TRIGGER_SHOW_CART_ITEM_EDITED_MODAL,
  TRIGGER_EDIT_CART_ITEM,
  TRIGGER_UPDATE_QUOTATION_LINE,
  SET_MAX_CONN_LEAD_TIME,
  SET_SHOPPING_CART_ID,
  SET_CART_LENGTH,
  SET_CURRENCY,
  SET_ADDITIONAL_CART_DETAILS,
  RESET_SHOPPING_CART,
  SET_QUOTATION_CART_ID,
} from '../../constants';

export interface IShoppingCartReducerState {
  triggerAddToShoppingCart: boolean;
  triggerShowAddedToCartModal: boolean;
  currentlyEditingShoppingCartLineId: number | null;
  currentlyEditingShoppingCartLineQuantity: number | null;
  triggerShowCartItemEditedModal: boolean;
  triggerEditCartItem: boolean;
  triggerUpdateQuotationLine: boolean;
  maxConnLeadTime: number;
  shoppingCartId: string | null;
  quotationCartId: string | null;
  cartLength: number;
  currency: string | null;
  additionalCartDetails: string | null;
}

const INIT_STATE: IShoppingCartReducerState = {
  triggerAddToShoppingCart: false,
  triggerShowAddedToCartModal: false,
  currentlyEditingShoppingCartLineId: null,
  currentlyEditingShoppingCartLineQuantity: null,
  triggerShowCartItemEditedModal: false,
  triggerEditCartItem: false,
  triggerUpdateQuotationLine: false,
  maxConnLeadTime: 0,
  shoppingCartId: null,
  quotationCartId: null,
  cartLength: 0,
  currency: null,
  additionalCartDetails: null,
};

const shoppingCartReducer = (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case TRIGGER_ADD_TO_SHOPPING_CART:
      return {
        ...state,
        triggerAddToShoppingCart: action.payload,
      };
    case SET_CURRENTLY_EDITING_SHOPPING_CART_LINE_DATA:
      return {
        ...state,
        currentlyEditingShoppingCartLineId: action.payload.id,
        currentlyEditingShoppingCartLineQuantity: action.payload.quantity,
      };
    case SET_TRIGGER_SHOW_ADDED_TO_CART_MODAL:
      return {
        ...state,
        triggerShowAddedToCartModal: action.payload,
      };
    case SET_TRIGGER_SHOW_CART_ITEM_EDITED_MODAL:
      return {
        ...state,
        triggerShowCartItemEditedModal: action.payload,
      };
    case TRIGGER_EDIT_CART_ITEM:
      return {
        ...state,
        triggerEditCartItem: action.payload,
      };
    case TRIGGER_UPDATE_QUOTATION_LINE:
      return {
        ...state,
        triggerUpdateQuotationLine: action.payload,
      };
    case SET_MAX_CONN_LEAD_TIME:
      return {
        ...state,
        maxConnLeadTime: action.payload,
      };
    case SET_SHOPPING_CART_ID:
      return {
        ...state,
        shoppingCartId: action.payload,
      };
    case SET_QUOTATION_CART_ID:
      return {
        ...state,
        quotationCartId: action.payload,
      };
    case SET_CART_LENGTH:
      return {
        ...state,
        cartLength: action.payload,
      };
    case SET_CURRENCY:
      return {
        ...state,
        currency: action.payload,
      };
    case SET_ADDITIONAL_CART_DETAILS:
      return {
        ...state,
        additionalCartDetails: action.payload,
      };
    case RESET_SHOPPING_CART:
    case COMPANY_CHANGED:
      return {
        ...INIT_STATE,
      };
    default:
      return state;
  }
};

export default shoppingCartReducer;
